//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Steps } from 'vant'
import CSlot from '@/components/CSlot'

export default {
  name: 'CSteps',

  components: {
    ISteps: Steps,
    CSlot,
  },

  inheritAttrs: false,

  props: Steps.props,
}
